angular.module('env.data.services.ping', [])

    .service('pingService', function ($log, $q, $http, $interval, loadingShadowService) {
        var _this = this;
        var pingPromise;
        var reconnectPromise;

        /**
         * Ping server
         * @returns {Promise}
         */
        _this.ping = function () {
            if (pingPromise) {
                return pingPromise;
            }
            var deferred = $q.defer();
            $http.get(om.config.build.baseUrl + "/ping").then(
                function (resp) {
                    pingPromise = null;
                    if (resp && resp.status == 200) {
                        deferred.resolve();
                    } else {
                        deferred.reject();
                    }
                },
                function () {
                    pingPromise = null;
                    deferred.reject();
                }
            );

            pingPromise = deferred.promise;
            return pingPromise;
        };

        /**
         * Get the promise, that will be resolved only after successful ping.
         * Rejection of promise is not expected (only for unexpected $http errors)
         * @returns {Promise}
         */
        _this.whenConnected = function () {
            if (reconnectPromise) {
                return reconnectPromise;
            }

            var deferred = $q.defer();
            var pingCount = 0;

            var inAction = false;
            var interval = $interval(
                function () {
                    if (inAction) {
                        return;
                    }
                    inAction = true;
                    pingCount++;
                    try {
                        _this.ping().then(
                            function () {
                                inAction = false;
                                $interval.cancel(interval);
                                reconnectPromise = null;
                                deferred.resolve({pingCount: pingCount});
                            },
                            function () {
                                inAction = false;
                            }
                        );
                    } catch (e) {
                        $log.error("Unexpected pingService error", e);
                        inAction = false;
                        reconnectPromise = null;
                        deferred.reject("Unexpected pingService error: " + e.toString());
                        $interval.cancel(interval);
                    }
                }, 5000);

            reconnectPromise = deferred.promise;
            return reconnectPromise;
        };

        _this.blockTillConnected = function () {
            loadingShadowService.show();
            return _this.whenConnected().then(
                function(r) {
                    loadingShadowService.hide();
                    return r;
                },
                function(r) {
                    loadingShadowService.hide();
                    return $q.reject(r);
                }
            );
        };

        return _this;
    })

;
